import { render, staticRenderFns } from "./signal.vue?vue&type=template&id=d55bac64&scoped=true"
import script from "./signal.vue?vue&type=script&lang=ts"
export * from "./signal.vue?vue&type=script&lang=ts"
import style0 from "./signal.vue?vue&type=style&index=0&id=d55bac64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55bac64",
  null
  
)

export default component.exports